import {Link} from '@genomics-dev/denim-components';
import {
    useEffect,
    useMemo,
} from 'react';
import {
    FormattedMessage,
    useIntl,
} from 'react-intl';
import {useAmplitude} from '../../context';
import {Routes} from '../../Routes';

export function WhatHappensNext(props) {
    const {
        name,
        summary: {
            physicianReviewStatus,
        } = {},
    } = props;

    const intl = useIntl();
    const amplitude = useAmplitude();

    useEffect(() => {
        amplitude.logWhatHappensNextVisit();
    }, []);

    const titleKey = useMemo(() => {
        if (physicianReviewStatus === 'REORDER_PLACED') {
            return 'reorder';
        }

        return 'default';
    }, [physicianReviewStatus]);

    return (
        <>
            <div className={'left'}>
                <header>
                    <div
                        className={'is-caption name'}
                        data-test-id={'users-shortened-name'}
                    >
                        {name}
                    </div>
                    <h2
                        className={'page-title'}
                        data-test-id={'home-what-happens-next-title'}
                    >
                        <FormattedMessage id={`home.whatHappensNext.${titleKey}.title`} />
                    </h2>
                </header>
                <p>
                    <FormattedMessage id={'home.whatHappensNext.description.one'} />
                </p>
                <p>
                    <FormattedMessage id={'home.whatHappensNext.description.two'} />
                </p>
                <p className={'no-margin-bottom'}>
                    <FormattedMessage
                        id={'home.whatHappensNext.description.three'}
                        values={{
                            link: (chunk) => (
                                <Link
                                    className={'alternate'}
                                    href={Routes.HELP_CENTER}
                                    rel={'noreferrer'}
                                    target={'_blank'}
                                >
                                    {chunk}
                                </Link>
                            ),
                        }}
                    />
                </p>
            </div>
            <div className={'right'}>
                <img
                    alt={intl.formatMessage({id: 'common.testKitBox.alt'})}
                    src={'/images/health-insights-test-kit-box_520x600.jpg'}
                />
            </div>
        </>
    );
}
